"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const base64Image_1 = __importDefault(require("./base64Image"));
const date_1 = require("./date");
const password_1 = __importDefault(require("./password"));
const phoneNumber_1 = __importDefault(require("./phoneNumber"));
const zipCode_1 = __importDefault(require("./zipCode"));
const email_1 = __importDefault(require("./email"));
const integer_1 = __importDefault(require("./integer"));
const url_1 = __importDefault(require("./url"));
const sanitizeForHTMLJS_1 = __importDefault(require("./sanitizeForHTMLJS"));
// Add custom rules
Yup.addMethod(Yup.string, 'base64Image', base64Image_1.default);
Yup.addMethod(Yup.string, 'date', date_1.date);
Yup.addMethod(Yup.string, 'datetime', date_1.datetime);
Yup.addMethod(Yup.string, 'time', date_1.time);
Yup.addMethod(Yup.string, 'password', password_1.default);
Yup.addMethod(Yup.string, 'phoneNumber', phoneNumber_1.default);
Yup.addMethod(Yup.string, 'zipCode', zipCode_1.default);
Yup.addMethod(Yup.string, 'email', email_1.default);
Yup.addMethod(Yup.string, 'integer', integer_1.default);
Yup.addMethod(Yup.string, 'url', url_1.default);
Yup.addMethod(Yup.string, 'sanitizeForHTMLJS', sanitizeForHTMLJS_1.default);
exports.default = Yup;
